const authTypes = {
  AUTH_CLEAR_ERROR: 'AUTH_CLEAR_ERROR',
  AUTH_GET_USER: 'AUTH_GET_USER',
  AUTH_START_LOADING: 'AUTH_START_LOADING',
  AUTH_STOP_LOADING: 'AUTH_STOP_LOADING',
  AUTH_LOGIN: 'AUTH_LOGIN',
  AUTH_CLEAR_USER: 'AUTH_CLEAR_USER',
  AUTH_RESET_PASSWORD: 'AUTH_RESET_PASSWORD',
  AUTH_RESET_PASSWORD_RETURN: 'AUTH_RESET_PASSWORD_RETURN',
  AUTH_SEND_EMAIL_VERIFICATION: 'AUTH_SEND_EMAIL_VERIFICATION',
  AUTH_RECOVER_EMAIL: 'AUTH_RECOVER_EMAIL',
  AUTH_SET_CLAIMS: 'AUTH_SET_CLAIMS',
  AUTH_SET_ERROR: 'AUTH_SET_ERROR',
  AUTH_SET_IDS: 'AUTH_SET_IDS',
  AUTH_SET_MESSAGE: 'AUTH_SET_MESSAGE',
  AUTH_SET_VERIFICATION_TIME_OUT: 'AUTH_SET_VERIFICATION_TIME_OUT',
  AUTH_SET_VERIFICATION_EMAIL: 'AUTH_SET_VERIFICATION_EMAIL',
  AUTH_SET_STEP: 'AUTH_SET_STEP',
  AUTH_SET_USER: 'AUTH_SET_USER',
  AUTH_SIGNUP: 'AUTH_SIGNUP',
  AUTH_VERIFY_EMAIL: 'AUTH_VERIFY_EMAIL',
  AUTH_VERIFY_EMAIL_RETURN: 'AUTH_VERIFY_EMAIL_RETURN',
  AUTH_VERIFY_LOGIN: 'AUTH_VERIFY_LOGIN',
  AUTH_VERIFY_LOGIN_MOBILE: 'AUTH_VERIFY_LOGIN_MOBILE',
  AUTH_SET_MODAL: 'AUTH_SET_MODAL',
  AUTH_SET_USER_ACCOUNTS: 'AUTH_SET_USER_ACCOUNTS',
  AUTH_SET_FIREBASE_AUTH_MOBILE_STATE: 'AUTH_SET_FIREBASE_AUTH_MOBILE_STATE',
  AUTH_SET_PHONE_NUMBER: 'AUTH_SET_PHONE_NUMBER',
  FIREBASE_MFA_INIT: 'FIREBASE_MFA_INIT',
  FIREBASE_MFA_VERIFY_CODE: 'FIREBASE_MFA_VERIFY_CODE',
  FIREBASE_MFA_SET_VERIFICATION_PROPS: 'FIREBASE_MFA_SET_VERIFICATION_PROPS',
  FIREBASE_MFA_SUCCESS: 'FIREBASE_MFA_SUCCESS',
  FIREBASE_LOGIN_SUCCESS: 'FIREBASE_LOGIN_SUCCESS',
  SET_REFERRALS: 'SET_REFERRALS',
  FIREBASE_ADD_PHONE_NUMBER: 'FIREBASE_ADD_PHONE_NUMBER',
  FIREBASE_ADD_PHONE_NUMBER_SUCCESS: 'FIREBASE_ADD_PHONE_NUMBER_SUCCESS',
  FIREBASE_ADD_PHONE_NUMBER_ERROR: 'FIREBASE_ADD_PHONE_NUMBER_ERROR',
  FIREBASE_ADD_PHONE_NUMBER_SKIPPED: 'FIREBASE_ADD_PHONE_NUMBER_SKIPPED',
  REAUTHENTICATE: 'REAUTHENTICATE',
  AUTH_SET_IS_ENROLL_FIREBASE_SMS_2FA_ON_SIGNUP: 'AUTH_SET_IS_ENROLL_FIREBASE_SMS_2FA_ON_SIGNUP'
};

export default authTypes;
